import { z } from 'zod';

export const Branded_app_job_runsScalarFieldEnumSchema = z.enum(['id','branded_app_job_id','step','error_message','created_at','updated_at']);

export default Branded_app_job_runsScalarFieldEnumSchema;
